import { useEffect, useState } from "react";
import { setAuthorization, getLoggedinUser } from "./api_helper";
import { getMe } from "./kronaly_helper";

/**
 * Resuelve la membership del workspace activo (kronaly_workspace_id) del usuario
 * autenticado, junto con su employee_profile_id (cuando existe). Devuelve también
 * un derivado `isManager` (owner|admin|manager) útil para gating de UI.
 */
const useCurrentMembership = () => {
  const [me, setMe] = useState(null);
  const [membership, setMembership] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      const u = getLoggedinUser();
      if (u?.access_token) setAuthorization(u.access_token);
      try {
        const r = await getMe();
        const data = r?.data ?? r;
        if (!mounted) return;
        setMe(data);
        const wid = localStorage.getItem("kronaly_workspace_id");
        const found =
          (data?.memberships || []).find((m) => m.workspace_id === wid) ||
          data?.memberships?.[0] ||
          null;
        setMembership(found || null);
      } catch (e) {
        if (mounted) {
          setError(typeof e === "string" ? e : e?.message || "No se pudo cargar el usuario.");
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };
    run();
    return () => {
      mounted = false;
    };
  }, []);

  const role = membership?.role || null;
  const employeeProfileId = membership?.employee_profile_id || null;
  // Zona configurada del workspace (única fuente de verdad para formatear
  // instantes). El backend (/me) ya aplica fallback 'UTC' espejo del resolver.
  const timezone = membership?.timezone || "UTC";
  const isManager = ["owner", "admin", "hr", "manager"].includes(role);
  const isAdmin = ["owner", "admin"].includes(role);
  const isHR = ["owner", "admin", "hr"].includes(role);
  const enabledModules = membership?.enabled_modules || [];
  const isModuleEnabled = (key) => enabledModules.includes(key);
  const capabilities = membership?.capabilities || [];
  const can = (capability) => capabilities.includes(capability);

  return {
    me,
    membership,
    loading,
    error,
    role,
    employeeProfileId,
    timezone,
    isManager,
    isAdmin,
    isHR,
    enabledModules,
    isModuleEnabled,
    capabilities,
    can,
  };
};

export default useCurrentMembership;
